import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

//* MUI
import { Card, Typography } from "@mui/material";

//* NDBX  Components
import { Section } from "@arp/react-ndbx";

//----------------------------------------------------------------

export default function PaymentContactDetailsHeader({ ...props }) {
  const { policyReferenceNumber = "", firstName = "" } = {
    ...props,
  };

  return (
    <Card
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: "#F1F9FA",
        pt: 4,
        pb: 4,
      }}
    >
      <Section mt={0}>
        <Typography variant="h2-bold">Contact details</Typography>
      </Section>
      <Section mt={4}>
        <Typography variant="p2">
          {`Hi ${firstName}, this is your application progress`}
        </Typography>
      </Section>
      <Section mt={0}>
        <Typography variant="p2-bold">
          {`Quote reference:  ${policyReferenceNumber}`}
        </Typography>
      </Section>
      <Section mt={{ xs: 2, md: 6 }} xs={10} md={12}>
        <Typography variant="h3-bold"> Make sure we can contact you</Typography>
      </Section>
      <Section sx={{ maxWidth: { xs: 636 } }}>
        <Typography variant="p2">
          We'll contact you with important information about your policy, so
          make sure all details are correct and up to date
        </Typography>
      </Section>
    </Card>
  );
}
